import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/webphu.phucbaokhang.com.vn/httpdocs/app/src/app/(authen)/login/LoginClient.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/webphu.phucbaokhang.com.vn/httpdocs/app/src/styles/login.css");
